import { shallowRef } from 'vue'
import type { Project, Folder } from '../types/domain'
export interface DirectoryContext { projects: Project[]; folders: Folder[]; projectId: string|null; folderId: string|null; review: boolean; shared: boolean }
export const directory = shallowRef<DirectoryContext>({projects:[],folders:[],projectId:null,folderId:null,review:false,shared:true})
let navigate: (project: string, folder: string|null) => void = () => {}
export function connectDirectory(handler: typeof navigate) { navigate = handler }
export function publishDirectory(context: DirectoryContext) { directory.value = context }
export function openDirectoryLocation(project: string, folder: string|null) { navigate(project, folder) }
